<template>

  <div>

    <div class="bg-white">
      <br class="d-none d-lg-block">
    	<br>
    	<div class="container py-1">
    	  <br class="d-none d-md-block">
    	  <div class="row">
    	    <div class="col-md-6">
            <p class="small grey text-uppercase mb-2"><a href="/trailer-rental">{{`Trailer Rental in ${countriesStr('and')}`}}</a>:</p>
    	      <h1 class="h2">Dolly Trailer Rental</h1>
    	      <p class="lead grey">Rent a Dolly Trailer with <strong>PNO Rental</strong> for your next transportation need.</p>
    				<hr>
    				<p class="text-lg d-none d-sm-block">Find a Dolly Trailer that fit your transportation needs. Simply request your Dolly Trailer available for short-term rental with PNO Rental.</p>
    				<p><a href="/trailers?category=dolly" class="btn btn-lg btn-success">Search Dolly Trailers <i class="fa fa-chevron-right ml-1"></i></a></p>
    	    </div>
             <div class="col-md-6 col-xl-5 offset-xl-1">
                <img :src="require('@/assets/img/type_dolly.jpg')" class="img-fluid mb-3" alt="Dolly Trailer Rental">
            </div>
    	  </div>
    	</div>
    	<br class="d-none d-md-block">
    </div>

    <div class="container py-4">
    	<br class="d-none d-md-block">
    	<h2 class="h4">Dolly trailer features</h2>
    	<p class="lead grey">Dollies are the most common choice for cost-effective 25.25 m traffic.</p>
    	<hr>
    	<br>
    	<div class="row">
    	  <div class="col-md-4">
    			<h5>Standard</h5>
    			<p class="grey">1 fifth wheel driving height for standard trailers.</p>
    	  </div>
    	  <div class="col-md-4">
    			<h5>Mega</h5>
    			<p class="grey">2 fifth wheel driving height for flexibility to drive standard or mega trailers.</p>
    	  </div>
    	</div>
        <hr>
    	<p class="small grey">The specifications listed are based upon PNO's most commonly rented trailers. They are not the exact measurements of all trailers rented by PNO. Specifications will vary by make, model and year of trailer.</p>
    </div>
  
  	<pno-how />

  	<pno-prompt />

  </div>

</template>

<script>
import PnoHow from '@/components/PnoHow.vue'
import PnoPrompt from '@/components/PnoPrompt.vue'
import { countriesStr } from '@/assets/countries';

export default {
	methods: {
		countriesStr
	},
    mounted() {
        this.$store.commit('meta/title', 'Dolly Trailer for Short-term Rental')
        this.$store.commit('meta/description', 'Rent a Dolly Trailer with PNO Rental for your next transportation need. Get your quote today!')
        this.$store.commit('meta/image', this.generateSmartImgUrl(require('@/assets/img/type_dolly.jpg') , 'ogimage'));
    },
	components: { PnoHow, PnoPrompt },
}
</script>
